import { render, staticRenderFns } from "./Prospectus.html?vue&type=template&id=3ce7097b&"
import script from "./Prospectus.ts?vue&type=script&lang=ts&"
export * from "./Prospectus.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports